import { toast } from "sonner";

const URL =
  (globalThis.constructor.name === "Window" && location.hostname === "localhost"
    ? "http://localhost:8080"
    : "") + "/api/cidadao/";

interface RegisterCidadaoProps {
  id_gov: string;
  nome: string;
  email: string;
}

export default async function registerCidadao(data: RegisterCidadaoProps) {
  try {
    const res = await fetch(URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({...data, tipo_login: "VISITANTE"}),
    });
    if (!res.ok) {
      if (res.status === 409) toast.success("Usuário encontrado");
      else throw new Error("Erro ao cadastrar e-mail");
    } else toast.success("E-mail cadastrado com sucesso!");
  } catch (error) {
    console.error("Error fetching citizen:", error);
    throw error;
  }
  return true;
}
